import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-svg-sprite',
  templateUrl: './svg-sprite.component.html',
  styleUrls: ['./svg-sprite.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgSpriteComponent {}